import { Link } from "react-router-dom";
import { ShieldCheck, Vote } from "lucide-react";

export default function SiteFooter({ wordmark }: { wordmark: string }) {
  return (
    <footer className="bg-black text-white">
      {/* Closing call-to-action band */}
      <div className="mx-auto flex max-w-shell flex-col items-start justify-between gap-8 px-5 py-16 md:flex-row md:items-center md:px-10">
        <div>
          <p className="text-3xl font-medium leading-tight tracking-tight text-white md:text-4xl">
            Ready to shape the party?
          </p>
          <p className="mt-3 max-w-md text-base leading-relaxed text-white/65">
            Your ballot decides the date, menu, contribution, and transport. One private voting code,
            one vote per decision — every senior and junior counts.
          </p>
        </div>
        <Link
          to="/voting"
          className="inline-flex items-center gap-2.5 rounded-full bg-[#AFDDFF] px-7 py-4 font-manrope text-[15px] font-medium uppercase tracking-[0.04em] text-black transition-all hover:bg-[#c8e8ff] active:scale-95"
        >
          <Vote className="h-4 w-4" aria-hidden="true" />
          Cast Your Votes
        </Link>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-shell flex-col items-start justify-between gap-8 px-5 py-12 md:flex-row md:items-center md:px-10">
          <div>
            <p className="font-graphik text-3xl text-white">{wordmark}</p>
            <p className="mt-2 max-w-md text-sm text-white/60">
              The official event portal for the BBA Freshers&rsquo; Party 2026, Commerce Department,
              Aligarh Muslim University. Organized by seniors and juniors of the BBA cohort.
            </p>
          </div>

          <nav aria-label="Footer" className="flex flex-wrap gap-x-8 gap-y-3">
            {[
              { label: "Overview", href: "/overview" },
              { label: "Menu", href: "/menu" },
              { label: "Voting", href: "/voting" },
              { label: "Budget", href: "/budget" },
              { label: "FAQs", href: "/faq" },
            ].map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="font-sans text-[13px] font-medium uppercase tracking-[0.08em] text-white/70 transition-colors hover:text-white"
              >
                {link.label}
              </Link>
            ))}
            <a
              href="/admin/login"
              className="font-sans text-[13px] font-medium uppercase tracking-[0.08em] text-wandor-prompt transition-colors hover:text-white"
            >
              Committee
            </a>
          </nav>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-shell flex-col items-start justify-between gap-3 px-5 py-5 text-xs text-white/55 md:flex-row md:items-center md:px-10">
          <p>
            © 2026 BBA Freshers&rsquo; Party organizing committee. Planning estimates only — no
            payments are processed on this site.
          </p>
          <p className="flex items-center gap-1.5">
            <ShieldCheck className="h-3.5 w-3.5 text-wandor-prompt" aria-hidden="true" />
            Private voting codes · aggregate results only
          </p>
        </div>
      </div>
    </footer>
  );
}
